import { useEffect, useRef, useState } from "react"
import gsap from "gsap"
import PointGallery from "./PointGallery"

const htmlByPoint = {
    1: null,
    2: null,
    3: null,
    4: <PointGallery images={[
        { src: "/img/old-site/7fitness.jpg",},
        { src: "/img/old-site/artgraph.jpg" },
        { src: "/img/old-site/kalinowski.jpg" },
        { src: "/img/old-site/kayakmed.jpg" },
        { src: "/img/old-site/keephearth.jpg" },
        { src: "/img/old-site/lineup.jpg" },
        { src: "/img/old-site/locationsete.jpg" },
        { src: "/img/old-site/maestrom.jpg" },
        { src: "/img/old-site/mm.jpg" },
        { src: "/img/old-site/montperal.jpg" },
        { src: "/img/old-site/naima.jpg" },
        { src: "/img/old-site/oa.jpg" },
        { src: "/img/old-site/sudexpertise.jpg" },
    ]} />,
    5: null,
    6: null,
    7: null,
    8: null,
    9: <ButtonProejct title={"Landing Maestrom"} href={'https://landing.maestrom-digital.fr'} />,
    10: <ButtonProejct title={"LineUp Ocean"} href={'https://landing.lineup-ocean.com'} />,
    11: <ButtonProejct title={"First webGl Project"} href={'https://showroom.maestrom-digital.fr/'} />,
    12: <ButtonProejct title={"Castle Bloc"} href={'https://castlebloc.vercel.app/'} />,
    13: <ButtonProejct title={"Téléphérique"} href={'https://telepherique-eight.vercel.app/'} />,
    14: <ButtonProejct title={"Rock Interactive Shader"} href={'https://fragment-ten-gold.vercel.app/'} />,
}

export default function HtmlByPoint({ activeInterestPointId }) {
    const htmlNode = activeInterestPointId != null ? htmlByPoint[activeInterestPointId] : null
    const showHtml = !!htmlNode

    return <HtmlPresence show={showHtml} html={htmlNode} htmlKey={activeInterestPointId} />
}

function HtmlPresence({ show, html, htmlKey }) {
    const wrapRef = useRef(null)
    const tlRef = useRef(null)
    const [mounted, setMounted] = useState(false)
    const [displayedHtml, setDisplayedHtml] = useState(null)
    const prevShowRef = useRef(false)

    useEffect(() => {
        const el = wrapRef.current
        const prevShow = prevShowRef.current
        prevShowRef.current = show

        if (show) {
            setMounted(true)
            setDisplayedHtml(html)
            return
        }

        if (!prevShow) return

        if (!el) {
            setMounted(false)
            setDisplayedHtml(null)
            return
        }

        if (tlRef.current) tlRef.current.kill()
        tlRef.current = gsap.timeline({
            onComplete: () => {
                setMounted(false)
                setDisplayedHtml(null)
            },
        }).to(el, { autoAlpha: 0, y: 12, duration: 0.25, ease: "power2.in" })
    }, [show])

    useEffect(() => {
        if (!mounted) return
        if (!show) return
        const el = wrapRef.current
        if (!el) return

        if (tlRef.current) tlRef.current.kill()

        gsap.set(el, { autoAlpha: 0, y: 12 })
        tlRef.current = gsap.timeline().to(el, {
            autoAlpha: 1,
            y: 0,
            duration: 0.35,
            ease: "power2.out",
        })
    }, [mounted, show, htmlKey])

    if (!mounted) return null

    return (
        <div ref={wrapRef} className="html-container">
            {displayedHtml}
        </div>
    )
}

function ButtonProejct({ title, href }) {
    return (
        <div className="project-container">
            <h1 className="mattone">{title}</h1>
            <div className="btn-container mattone">
                <a target="_blank" href={href}>LIVE PROJECT</a>
            </div>
        </div>
    )
}